module.exports = __webpack_public_path__ + "media/images/gallery/stars/orion/betelgeuse_vis-92bd7bf7eec44fca016e453cea69280f.jpg";